(function () {
  function getOptionFieldset(optionName) {
    const picker = document.querySelector('variant-picker');
    if (!picker) return null;
    return Array.from(picker.querySelectorAll('fieldset.variant-option')).find((f) => {
      const name = (
        f.dataset.optionName ||
        f.dataset.option ||
        f.querySelector('legend')?.textContent ||
        ''
      ).toLowerCase();
      return name.includes(optionName);
    }) || null;
  }

  function getSelectedValue(optionName) {
    const fieldset = getOptionFieldset(optionName);
    if (!fieldset) return '';
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    return (checked?.value || '').toLowerCase().trim();
  }

  function getAllValues(optionName) {
    const fieldset = getOptionFieldset(optionName);
    if (!fieldset) return [];
    return Array.from(fieldset.querySelectorAll('input[type="radio"]'))
      .map((i) => i.value.toLowerCase().trim())
      .filter(Boolean);
  }

  // Generic option definition: works for color, size, or anything else you add later.
  function buildOptions() {
    const colorSelected = getSelectedValue('color') || getSelectedValue('colour');
    const colorAll = getAllValues('color').concat(getAllValues('colour'));

    const sizeSelected = getSelectedValue('size');
    const sizeAll = getAllValues('size');

    return [
      { name: 'color', selected: colorSelected, all: colorAll },
      { name: 'size', selected: sizeSelected, all: sizeAll },
    ].filter((opt) => opt.selected && opt.all.length);
  }

  // Applies filtering to a list of gallery/thumbnail items using the given options.
  // For each option, if NOTHING in this item set actually matches the selected value
  // (e.g. alt text doesn't follow the expected tagging convention on this product),
  // that option is ignored entirely instead of hiding everything or nothing.
  function applyFilter(items, options) {
    if (!items.length || !options.length) {
      items.forEach((item) => item.classList.remove('variant-media-hidden'));
      return;
    }

    const getAlt = (item) => (item.querySelector('img')?.alt || '').toLowerCase().trim();

    const anyMatch = options.map(() => false);

    items.forEach((item) => {
      const alt = getAlt(item);
      options.forEach((opt, i) => {
        const isTagged = opt.all.some((v) => alt === v || alt.includes(v));
        if (isTagged && alt.includes(opt.selected)) anyMatch[i] = true;
      });
    });

    items.forEach((item) => {
      const alt = getAlt(item);
      let show = true;

      options.forEach((opt, i) => {
        if (!anyMatch[i]) return; // fallback: this option isn't reliably tagged here, so don't filter by it
        const isTagged = opt.all.some((v) => alt === v || alt.includes(v));
        if (isTagged && !alt.includes(opt.selected)) show = false;
      });

      item.classList.toggle('variant-media-hidden', !show);
    });
  }

  function filterGallery() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const options = buildOptions();
    console.log('[Filter] options:', options.map(o => `${o.name}=${o.selected}`).join(', ') || '(none)');

    const mainItems = Array.from(gallery.querySelectorAll('li.product-media-container, slideshow-slide'));
    const thumbItems = Array.from(gallery.querySelectorAll('.slideshow-controls__thumbnail, .dialog-thumbnails-list__thumbnail'));

    applyFilter(mainItems, options);
    applyFilter(thumbItems, options);

    console.log('[Filter] hidden:', gallery.querySelectorAll('.variant-media-hidden').length);
  }

  function attachVariantPickerListener() {
    const picker = document.querySelector('variant-picker');
    if (!picker) return;
    picker.addEventListener('variant:update', () => {
      setTimeout(filterGallery, 100);
      setTimeout(filterGallery, 300);
      setTimeout(filterGallery, 600);
    });
  }

  function attachSectionObserver() {
    const section = document.querySelector('.shopify-section:has(media-gallery)');
    if (!section) return;
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeName === 'MEDIA-GALLERY') {
            setTimeout(filterGallery, 100);
            setTimeout(filterGallery, 400);
          }
        }
      }
    }).observe(section, { childList: true, subtree: false });
  }

  function init() {
    console.log('[Filter] init');
    filterGallery();
    attachVariantPickerListener();
    attachSectionObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();